<template>
  <w-modal
    v-model="show"
    title="Generowanie dokumentów"
    class="modal-big"
    :show-close-button="false"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="$emit('close')"
    @close="$emit('close')"
  >
    <div class="row mb-2">
      <div class="form-group col-12">
        Do wygenerowania dokumentu zostaną użyte zaznaczone dokumenty.
      </div>

      <div class="form-group col-12">
        <select id="view" v-model="selectedView" class="form-control">
          <option v-for="view in views" :key="'view_' + view.id" :value="view.id">
            {{ view.name }}
          </option>
        </select>
      </div>
    </div>

    <w-input :model="$schema.caseId" @input="loadDocumentName($schema.caseId.$model, 'mdok/getCaseName')" />

    <p v-if="caseName">
      Wybrano sprawę: <b>{{ caseName }}</b>
    </p>

    <schema-form v-if="loadedSchema && schema" :template-name="$schema.$title" :schema="$schema" />

    <div slot="footer" class="w-100">
      <w-button class="btn btn-secondary float-left mr-2" text="Zamknij" @click="close" />

      <div class="float-right">
        <w-button
          v-if="mdokEnabled && view"
          class="btn-primary mr-2"
          text="Prześlij do MDOK"
          :disabled="disableButtons"
          @click="sendToMDOK"
        />

        <w-button
          v-if="view"
          class="btn-primary mr-2"
          text="Zapisz w systemie"
          :disabled="disableButtons"
          @click="saveAsAttachment"
        />

        <post-form
          v-if="pdfUrl"
          text="Pobierz pdf"
          icon="fal fa-cloud-download mr-2"
          button-class="btn-primary"
          :disabled="disableButtons"
          :fields="postData"
          :url="pdfUrl"
        />
      </div>
    </div>
  </w-modal>
</template>

<script>
import SchemaForm from '@/components/forms/SchemaForm';
import PostForm from '@/components/postForm/PostForm';
import { Errors } from '@/enums/errors.enum';
import { Successes } from '@/enums/successes.enum';
import { formMixin } from '@/mixins/form';
import { generateMixin } from '@/mixins/generate';
import { mdokDocumentMixin } from '@/mixins/mdokDocument';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/procedureGenerate.schema';
import { config } from '@/utils/config';
import { tryParseInt } from '@/utils/number';

// @vuese
// Modal wyboru statusu
// @group
export default {
  components: { PostForm, SchemaForm },
  mixins: [formMixin, generateMixin, mdokDocumentMixin, notificationsMixin],
  props: {
    // Czy modal ma być widoczny
    show: { type: Boolean, required: true },
    // Filtry dokumentów
    filters: { type: Array, required: true }
  },
  schema,
  data() {
    return { model: {}, isUploading: false, mdokEnabled: config.mdokEnabled };
  },
  computed: {
    // Aktalnie wybrany widok
    view() {
      return this.selectedView && this.views.find(view => view.id === this.selectedView);
    },
    // URL do generowania PDF
    pdfUrl() {
      return (
        this.view &&
        config.renderURL +
          `/pdf/documents/${this.view.id}?procedureId=${this.procedureId}${
            this.view.singleView ? '&singleView=true' : ''
          }`
      );
    },
    // Dane formularza generującego PDF
    postData() {
      return [...this.viewFormFields, ...this.filters];
    },
    procedureId() {
      return this.$route.params.procedureId.toString();
    },
    disableButtons() {
      return this.postFormsDisabled || this.isUploading;
    },
    filtersAsObject() {
      const filterObject = {};
      this.filters.forEach(element => {
        filterObject[element.name] = element.value;
      });

      return filterObject;
    }
  },
  methods: {
    // @vuese
    // Ładuje schemę
    loadSchema() {
      this.model = {};
      if (this.schema) {
        this.$setSchema({ allOf: [this.schema, schema] });
      } else {
        this.$setSchema(schema);
      }
      this.loadedSchema = true;
    },
    // @vuese
    // Zapisuje widok jako załącznik
    saveAsAttachment() {
      this.save('view/saveGroupAsAttachment');
    },
    // @vuese
    // Zapisuje widok jako załącznik i przesyła do MDOk
    sendToMDOK() {
      this.save('view/sendGroupToMDOK', true);
    },
    // @vuese
    // Zapisuje widok używając odpowiedniej akcji
    save(action, withCaseId) {
      this.isUploading = true;
      const data = this.$schema.$getData();
      this.$store
        .dispatch(action, {
          caseId: withCaseId ? data.caseId : undefined,
          viewId: this.view.id,
          procedureId: tryParseInt(this.procedureId),
          data: { ...data, ...this.filtersAsObject },
          singleView: this.view.singleView
        })
        .then(() => {
          this.notifySuccess(Successes.ATTACHMENT_SAVED);
        })
        .catch(err => this.notifyError(Errors.ERROR_TRY_AGAIN_LATER))
        .finally(() => (this.isUploading = false));
    }
  }
};
</script>
